/*
  Native Possum — np-bed-guide.js
  The "On a bed" drawing in the size guide on throws and blankets
  (snippets/np-size-guide.liquid). Tap a bed and the throw is redrawn to
  scale, laid across the foot of that bed, with a line saying how it sits.

  Bed sizes come from the "NZ bed sizes" Size chart entry in admin, rendered
  as the chip buttons; the throw's size from its own measurements. Nothing
  is hard-coded here.

  Phones get a short list instead of the drawing (one line per bed, the best
  fit marked): the phone size sheet calls window.npBedGuide.list(guide).
  Both use the same wording from fit() below.
*/
(function () {
  'use strict';

  var W = 300, H = 330, PAD = 12, TOP = 26;
  var NS = 'http://www.w3.org/2000/svg';

  function num(v) { var n = parseFloat(v); return isNaN(n) ? 0 : n; }
  function fmt(n) { return (Math.round(n * 10) / 10).toString(); }
  // "Queen (US Queen)" -> "Queen" for the label drawn on the bed
  function shortName(name) { return name.replace(/\s*\(.*\)\s*$/, ''); }

  function el(tag, attrs, text) {
    var e = document.createElementNS(NS, tag);
    for (var k in attrs) e.setAttribute(k, attrs[k]);
    if (text) e.textContent = text;
    return e;
  }

  // How a throw of this width sits across the foot of a bed this wide.
  function fit(across, bedW) {
    var over = across - bedW;
    if (over > 4) return { kind: 'over', n: Math.round(over / 2) };
    if (over >= -4) return { kind: 'width' };
    return { kind: 'covers', n: Math.round(across / bedW * 100) };
  }

  function sizes(root) {
    var a = num(root.dataset.throwWidth), b = num(root.dataset.throwLength);
    return { across: Math.max(a, b), down: Math.min(a, b) }; // longer side runs across the bed
  }

  function draw(root, chip) {
    var svg = root.querySelector('svg');
    var caption = root.querySelector('.np-bed-guide__caption');
    var bedLine = root.querySelector('.np-bed-guide__bed');
    var chips = root.querySelectorAll('.np-bed-chip');

    var t = sizes(root), across = t.across, down = t.down;
    var name = chip.dataset.bed, bedW = num(chip.dataset.width), bedL = num(chip.dataset.length);

    // One scale for every bed, so switching beds shows the real difference.
    var maxW = 0, maxL = 0;
    chips.forEach(function (c) {
      maxW = Math.max(maxW, num(c.dataset.width));
      maxL = Math.max(maxL, num(c.dataset.length));
    });
    maxW = Math.max(maxW, across);
    var s = Math.min((W - PAD * 2) / maxW, (H - TOP - PAD) / (maxL + 10));

    var bw = bedW * s, bl = bedL * s, x = (W - bw) / 2, y = TOP;
    var tw = across * s, tl = down * s, tx = (W - tw) / 2, ty = y + bl - tl + 6;

    while (svg.firstChild) svg.removeChild(svg.firstChild);
    svg.appendChild(el('rect', { x: x - 6, y: y - 14, width: bw + 12, height: 14, rx: 3, fill: '#cfc6ba' })); // np-colour-data
    svg.appendChild(el('rect', { x: x, y: y, width: bw, height: bl, rx: 4, fill: '#fff', stroke: '#bdb5aa', 'stroke-width': 1.5 })); // np-colour-data
    svg.appendChild(el('rect', { x: x + bw * 0.12, y: y + 8, width: bw * 0.34, height: bl * 0.11, rx: 6, fill: '#ede7df' })); // np-colour-data
    svg.appendChild(el('rect', { x: x + bw * 0.54, y: y + 8, width: bw * 0.34, height: bl * 0.11, rx: 6, fill: '#ede7df' })); // np-colour-data
    svg.appendChild(el('rect', { x: tx, y: ty, width: tw, height: tl, rx: 3, style: 'fill: var(--np-brand-green)', 'fill-opacity': 0.85 })); // np-colour-data (the drawing's item)
    svg.appendChild(el('text', { x: W / 2, y: ty + tl / 2 + 4, 'text-anchor': 'middle', 'font-size': 12, fill: '#fff' }, fmt(across) + ' × ' + fmt(down) + 'cm'));

    svg.setAttribute('aria-label', 'A ' + fmt(across) + ' by ' + fmt(down) + 'cm throw across the foot of a ' + name + ' bed, ' + fmt(bedW) + ' by ' + fmt(bedL) + 'cm');

    // The bed's name and size sit above the drawing, where the throw can't cover them
    if (bedLine) {
      bedLine.textContent = shortName(name) + ' ';
      var small = document.createElement('span');
      // Seen as "· 153 × 203cm"; said as "153 by 203 centimetres", not "times"
      small.setAttribute('aria-hidden', 'true');
      small.textContent = '· ' + fmt(bedW) + ' × ' + fmt(bedL) + 'cm';
      var said = document.createElement('span');
      said.className = 'np-visually-hidden';
      said.textContent = fmt(bedW) + ' by ' + fmt(bedL) + ' centimetres';
      bedLine.appendChild(small);
      bedLine.appendChild(said);
    }

    var f = fit(across, bedW), text;
    if (f.kind === 'over') text = 'Hangs about ' + f.n + 'cm over each side of a ' + name + '.';
    else if (f.kind === 'width') text = 'About the width of a ' + name + ' — sits neatly across the foot.';
    else text = 'Covers ' + f.n + '% of a ' + name + '’s width — a throw across the foot rather than a full cover.';
    caption.textContent = text;

    chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
  }

  function init(root) {
    if (!root || root.hasAttribute('data-np-bed-ready')) return;
    var chips = root.querySelectorAll('.np-bed-chip');
    if (!chips.length || !num(root.dataset.throwWidth) || !num(root.dataset.throwLength)) return;
    root.setAttribute('data-np-bed-ready', '');

    root.addEventListener('click', function (e) {
      var chip = e.target.closest('.np-bed-chip');
      if (chip && root.contains(chip)) draw(root, chip);
    });

    // Start on Queen, NZ's most common bed.
    var start = root.querySelector('.np-bed-chip[aria-pressed="true"]');
    if (!start) {
      chips.forEach(function (c) { if (!start && /^queen/i.test(c.dataset.bed)) start = c; });
    }
    draw(root, start || chips[Math.floor(chips.length / 2)]);
    root.hidden = false;
  }

  function initAll() {
    document.querySelectorAll('.np-bed-guide').forEach(init);
  }

  // Phone version: every bed on one line, the closest fit marked. Built from
  // a bed guide's markup; returns the list element (or null).
  function list(root) {
    var chips = root ? root.querySelectorAll('.np-bed-chip') : [];
    if (!chips.length) return null;
    var across = sizes(root).across;
    var best = null, bestGap = Infinity;
    chips.forEach(function (c) {
      var gap = Math.abs(across - num(c.dataset.width));
      if (gap < bestGap) { bestGap = gap; best = c; }
    });

    var wrap = document.createElement('div');
    wrap.className = 'np-bed-list';
    var title = document.createElement('p');
    title.className = 'np-bed-guide__title';
    var srcTitle = root.querySelector('.np-bed-guide__title');
    title.textContent = srcTitle ? srcTitle.textContent : 'On a bed';
    wrap.appendChild(title);

    var ul = document.createElement('ul');
    ul.className = 'np-bed-list__rows';
    chips.forEach(function (c) {
      var f = fit(across, num(c.dataset.width)), text;
      if (f.kind === 'over') text = 'hangs ' + f.n + 'cm each side';
      else if (f.kind === 'width') text = 'about the width';
      else text = 'covers ' + f.n + '% of the width';
      var li = document.createElement('li');
      li.className = 'np-bed-list__row' + (c === best ? ' is-best' : '');
      var nameEl = document.createElement('span');
      nameEl.textContent = c.dataset.bed;
      var fitEl = document.createElement('span');
      fitEl.className = 'np-bed-list__fit';
      fitEl.textContent = (c === best ? 'Best fit · ' : '') + text;
      li.appendChild(nameEl);
      li.appendChild(fitEl);
      ul.appendChild(li);
    });
    wrap.appendChild(ul);

    var note = document.createElement('p');
    note.className = 'np-bed-list__note';
    var bedNote = root.querySelector('.np-bed-guide__note');
    note.textContent = 'Laid across the foot of the bed.' + (bedNote ? ' ' + bedNote.textContent.trim() : '');
    wrap.appendChild(note);
    return wrap;
  }

  window.npBedGuide = { init: init, list: list };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
